<template>
  <div class="role">
    <Header :present-page="presentPage" />
    <a-row class="warp">
      <a-col :span="16">
        <a-row class="top">
          <a-col class="ipt">
            <span>名称</span>
            <a-input
              v-model:value="menuName"
              placeholder="请输入"
            />
          </a-col>
          <a-col class="operate">
            <a-button
              type="primary"
              @click="search"
            >搜索</a-button>
            <a-button
              type="default"
              @click="reset"
            >重置</a-button>
          </a-col>
          <a-col>
            <a-dropdown
              :placement="placement"
              :trigger="['click', 'hover']"
            >
              <a
                class="ant-dropdown-link"
                @click.prevent
              >
                <a-button>更多操作</a-button>
              </a>
              <template #overlay>
                <a-menu>
                  <a-menu-item @click="addModalShow">
                    <a href="javascript:;">添加</a>
                  </a-menu-item>
                  <a-menu-item @click="alterModalShow">
                    <a href="javascript:;">修改</a>
                  </a-menu-item>
                  <a-menu-item @click="delModalShow">
                    <a href="javascript:;">删除</a>
                  </a-menu-item>
                  <!-- <a-menu-item>
                    <a href="javascript:;">导出</a>
                  </a-menu-item> -->
                </a-menu>
              </template>
            </a-dropdown>
          </a-col>
        </a-row>
        <a-tree
          checkable
          checkStrictly
          autoExpandParent
          :tree-data="treeData"
          :replace-fields="replaceFields"
          v-model:expanded-keys="expandedKey"
          @check="check"
        />
      </a-col>
      <a-col
        class="right"
        :span="8"
      >
        <AddMenu
          ref="addMenu"
          :menu-list="treeData"
          :checked-key="checkedKey"
          :checked-title="checkedTitle"
          @confirm="init"
        />
        <Altermenu
          ref="altermenu"
          :menu-list="treeData"
          :checked-key="checkedKey"
          :checked-title="checkedTitle"
          :present="present"
          @confirm="init"
        />
        <DelModal
          ref="DelModal"
          @confirm="confirmDel"
        />
      </a-col>
    </a-row>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/header/header.vue";
import AddMenu from "@/components/system/menu/add.vue";
import Altermenu from "@/components/system/menu/alter.vue";
import DelModal from "@/components/delModal.vue";
import { menuList, delMenu } from "@/api/system/system.js";

export default {
  name: "Menu",
  components: {
    Header,
    AddMenu,
    Altermenu,
    DelModal,
  },
  data() {
    return {
      presentPage: '',
      menuName: '',
      placement: 'bottomCenter',
      query: {},
      treeData: [],
      replaceFields: {
        key: 'id',
      },
      expandedKey: [], //展开指定的树节点
      checkedKey: 0,
      checkedTitle: '',
      present: {}
    }
  },
  mounted() {
    this.presentPage = this.$route.query.name
    this.init()
  },
  methods: {
    init() {
      menuList(this.query).then(res => {
        if (res.code == 200) {
          this.treeData = res.data.menuTree
          // console.log(this.treeData)
        }
      }).catch(res => {
        console.log(res)
      });
    },
    search() {
      this.menuName = ''
    },
    reset() {
      this.menuName = ''
    },
    addModalShow() {
      this.$refs.altermenu.hide();
      this.$refs.addMenu.show();
    },
    alterModalShow() {
      if (this.checkedKey) {
        this.$refs.addMenu.hide();
        this.$refs.altermenu.show();
      } else {
        this.$message.info('请选择要修改的菜单');
      }
    },
    delModalShow() {
      if (this.checkedKey) { // 单个删除
        this.$refs.DelModal.show();
        this.query = {
          menuIds: this.checkedKey
        }
      } else {
        this.$message.info('请选择要删除的部门');
      }
    },
    confirmDel() {
      delMenu(this.query).then(res => {
        if (res.code == 200) {
          this.init()
          this.$message.success('删除成功');
        }
      }).catch(res => {
        console.log(res)
      });
    },
    check(checkedKeys, e) {
      console.log(checkedKeys);
      console.log(e);
      if (checkedKeys.checked.length > 1) {
        checkedKeys.checked.splice(0, 1)
        this.checkedKey = checkedKeys.checked[0]
      }
      if (checkedKeys.checked.length == 1) {
        this.checkedKey = checkedKeys.checked[0]
      }
      this.checkedTitle = e.node.title
      this.present = e.node.dataRef
      if (checkedKeys.checked.length == 0) {
        this.checkedKey = 0
        this.checkedTitle = ''
      }
    },
  }
};
</script>
<style scoped>
.warp {
  margin: 20px 30px;
}
.top {
  height: 76px;
  margin: 0 20px 0 0;
  padding: 20px 30px;
  line-height: 36px;
  background: #fff;
}

.ipt {
  display: flex;
  justify-content: space-around;
  align-items: center;
  text-align: left;
}
.ipt span {
  margin-right: 10px;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 600;
  color: #222;
}
.ipt input {
  width: 236px;
  height: 36px;
  background: #fefefe;
  border: 1px solid #ddd;
  border-radius: 6px;
}
.ant-divider-vertical {
  height: 22px;
  margin: 0 15px;
  background: #dddddd;
}
.ant-select :deep() .ant-select-selector {
  width: 236px;
  height: 36px;
  background: #fefefe;
  border: 1px solid #dddddd;
  border-radius: 6px;
}
.ant-select :deep() .ant-select-selection-item {
  height: 34px;
  line-height: 34px;
}
.operate {
  text-align: left;
}
.operate button:nth-child(1) {
  width: 80px;
  height: 36px;
  margin: 0 20px;
  background: linear-gradient(-30deg, #0077ee, #33aaff);
  border-radius: 6px;
}
.operate button:nth-child(2) {
  width: 80px;
  height: 36px;
  margin-right: 20px;
  background: #fff;
  border: 1px solid #bbbbbb;
  border-radius: 6px;
}
.ant-dropdown-link button {
  height: 36px;
  background: #fff;
  border: 1px solid #bbbbbb;
  border-radius: 6px;
}
.ant-tree {
  margin: 0 20px 0 0;
  padding-bottom: 20px;
  text-align: left;
  background: #fff;
}
.right {
  padding: 22px;
  background: #fff;
}
.right :deep() h5 {
  padding-left: 10px;
  text-align: left;
  vertical-align: top;
  font-size: 20px;
  line-height: 1;
  font-weight: 600;
  color: #222;
  border-left: 5px solid #0088ff;
}
.right :deep() .ipt {
  align-items: flex-start;
}
.right :deep() .ipt input {
  width: 100%;
}
.right :deep() .a-btn {
  text-align: right;
}
.right :deep() .ant-form-item-label > label::after {
  content: " ";
}
.right :deep() .cancel {
  width: 80px;
  height: 36px;
  margin-right: 20px;
  color: #0088ff;
  background: #fff;
  border: 1px solid #0088ff;
  border-radius: 6px;
}
.right :deep() .confirm {
  width: 80px;
  height: 36px;
  color: #fff;
  border: 0;
  background: linear-gradient(-30deg, #0077ee, #33aaff);
  border-radius: 6px;
}
</style>
